module.exports = __webpack_public_path__ + "static/mainleft-a2101f2995df191da7065e23dff66f37.jpg";